import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledCervicalBreastCancerIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 9.5C21.8783 9.5 23.6171 10.5137 24.9033 12.2285C26.1896 13.9436 27 16.3363 27 19C27 21.6637 26.1896 24.0564 24.9033 25.7715C23.6171 27.4863 21.8783 28.5 20 28.5C18.1217 28.5 16.3829 27.4863 15.0967 25.7715C13.8104 24.0564 13 21.6637 13 19C13 16.3363 13.8104 13.9436 15.0967 12.2285C16.3829 10.5137 18.1217 9.5 20 9.5Z",
			fill: "#33BF8D",
			stroke: "#008355",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9014 23.5C26.0948 24.3575 28.0761 26.2783 29.0146 28.9619C29.2712 29.6954 28.6789 30.5 27.7344 30.5H12.2656C11.3214 30.5 10.7278 29.6958 10.9834 28.9609C11.9154 26.2809 13.8812 24.3662 16.0986 23.5H23.9014Z",
			fill: "#33BF8D",
			stroke: "#008355",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 21.5C22.1326 21.5 22.2598 21.5528 22.3535 21.6465C22.4473 21.7403 22.5 21.8674 22.5 22V21.9971L22.501 22.0117C22.5021 22.0293 22.5048 22.0601 22.5107 22.1016C22.5226 22.1847 22.5477 22.3111 22.5996 22.4668C22.703 22.7769 22.9146 23.2076 23.3535 23.6465C24.0248 24.3177 23.9981 25.2659 23.875 25.9209C23.6764 26.977 22.676 27.5 21.7637 27.5H18.2363C17.324 27.5 16.3236 26.977 16.125 25.9209C16.0019 25.2659 15.9753 24.3177 16.6465 23.6465C17.0854 23.2075 17.297 22.777 17.4004 22.4668C17.4523 22.3111 17.4774 22.1847 17.4893 22.1016C17.4952 22.0601 17.4979 22.0293 17.499 22.0117L17.5 21.9971V22C17.5 21.7239 17.7239 21.5001 18 21.5H22Z",
			fill: "white",
			stroke: "#008355",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 11.5C21.0996 11.5 22.1187 11.9203 22.8555 12.7871C23.5863 13.6471 24 14.8989 24 16.5C24 18.0991 23.5882 19.5702 22.8965 20.6572C22.2085 21.7384 21.1967 22.5 20 22.5C18.8033 22.5 17.7915 21.7384 17.1035 20.6572C16.4118 19.5702 16 18.0991 16 16.5C16 14.8989 16.4137 13.6471 17.1445 12.7871C17.8813 11.9203 18.9004 11.5 20 11.5Z",
			fill: "white",
			stroke: "#008355",
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 10.5L16 12.5L17 14L22 16L26 17.0001L24.5 13L22.5 11L20 10L18.5 10.5Z",
			fill: "#33BF8D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12.0001C16 14 19 15.5 23 16.0001C25.4143 16.302 26.5 18.5 27 20",
			stroke: "#008355"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 26.0625,
			cy: 26.0373,
			rx: 4.0625,
			ry: 4.03728,
			fill: "white",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.1875 29.1428L32 31.9379",
			stroke: "#1F3B44",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledCervicalBreastCancerIcon);
const Memo = memo(ForwardRef);
export default Memo;
